import { Home, Register, CreateJobs, Jobs, Error } from "./pages";
// import all files from ./pages

import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
function App() {
	return (
		<Router>
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/login" element={<Register />} />
				<Route path="/jobs" element={<CreateJobs />} />
				<Route path="/careers" element={<Jobs />} />
				<Route path="*" element={<Error />} />
			</Routes>
		</Router>
	);
}

export default App;
